import { render } from "./Greeting.vue?vue&type=template&id=69a5f1ae&scoped=true"
import script from "./Greeting.vue?vue&type=script&lang=js"
export * from "./Greeting.vue?vue&type=script&lang=js"

import "./Greeting.vue?vue&type=style&index=0&id=69a5f1ae&scoped=true&lang=css"

import exportComponent from "/Users/admin/Work/CIS_HOME/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a5f1ae"]])

export default __exports__